import React, { useContext } from "react";
import {
  Box,
  Flex,
  VStack,
  Link,
  Image,
  Heading,
  Divider,
  Text,
} from "@chakra-ui/react";
import { ContentContext } from "../context/ContentContext";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const Home = () => {
  const { movies, games } = useContext(ContentContext);
  return (
    <Box bg="gray.700" color="teal.200" p={8}>
      <Heading as="h2">Latest Movies</Heading>
      <Box p={4}>
        {movies.map((data, index) => {
          return (
            <Box
              d="inline-block"
              key={index}
              maxW="sm"
              borderWidth="1px"
              borderRadius="lg"
              m={2}
            >
              <Image
                boxSize="200px"
                objectFit="cover"
                loading="lazy"
                src={data.image}
                alt={data.title}
              />
            </Box>
          );
        })}
      </Box>
      <Divider />
      <VStack mt={4} align="items-start" justify="content-between" w="75%">
        {movies.map((data, index) => {
          return (
            <Flex justify="flex-start" align="items-center" key={index} p={4}>
              <Image
                w="200px"
                objectFit="cover"
                loading="lazy"
                mr={2}
                borderRadius="md"
                src={data.image}
                alt={data.title}
              />
              <Flex direction="column" p={4}>
                <Link href={`/movie/detail/${data.id}`}>
                  <Heading as="h3" size="lg" mb={4}>
                    {data.title}
                  </Heading>
                </Link>
                <Text>{data.description}</Text>
                <Link
                  href={`https://www.youtube.com/results?search_query=${data.title} trailer`}
                  mt={6}
                  isExternal
                >
                  Watch trailer on Youtube <ExternalLinkIcon mx="2px" />
                </Link>
              </Flex>
            </Flex>
          );
        })}
      </VStack>
    </Box>
  );
};

export default Home;
